import { useMemo } from 'react';

import {
  getActiveModuleIds,
  useAppData,
} from '@modules/_shared/providers/AppDataProvider';
import { isRATenantId } from '@shared/utils/tenant';

import { toLocalDay } from '../days';

import type { Viewer } from './audience';

export const useViewer = (): Viewer | null => {
  const { me } = useAppData();
  return useMemo(
    () =>
      me == null
        ? null
        : {
            tenantId: me.tenant_id,
            isRATenant: isRATenantId(me.tenant_id),
            countryCode: me.tenant.country_code,
            moduleIds: getActiveModuleIds(me),
            isTeamLeader: me.teams.some(team => team.is_leader),
            accountCreatedDay:
              me.created_at == null
                ? null
                : toLocalDay(new Date(me.created_at)),
          },
    [me],
  );
};
